
































import { Component, Mixins } from "vue-property-decorator";
import { RegisterHttp } from "@/utils/Decorators";
import RequestData from "@/store/types/RequestData";
import CompaniesMixin from "@/mixins/http/CompaniesMixin";
import { Company } from "@/models";
import Page from "@/views/Page.vue";
import CompanyShowTabs from "../Tabs.vue";
import CatalogueList from "@/components/Company/CatalogueList.vue";

@Component({ components: { Page, CompanyShowTabs, CatalogueList } })
export default class CompanyCatalog extends Mixins(CompaniesMixin) {
  private company: Company | null = null;

  static readonly getCompanyFamiliesTag = "get_company_families_tag";
  @RegisterHttp(CompanyCatalog.getCompanyFamiliesTag)
  getCompanyFamiliesRequest: RequestData;

  async created() {
    this.company = await this.loadCompany(this.getRouteId());
  }

  async loadCompany(id: string) {
    return await this.getCompany(id, CompanyCatalog.getCompanyFamiliesTag);
  }
  get companyLogo() {
    return {
      backgroundImage: `url(${
        this.company?.logo || require("@/assets/icons/placeholder.svg")
      })`,
    };
  }

  private getRouteId(): string {
    return this.$route.params.id;
  }
}
